/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16.1668 8V8C17.8742 8 18.7279 8 19.4091 8.25638C20.4872 8.66213 21.338 9.51294 21.7437 10.591C22.0001 11.2722 22.0001 12.1259 22.0001 13.8333V15.6C22.0001 17.8402 22.0001 18.9603 21.5641 19.816C21.1807 20.5686 20.5687 21.1805 19.8161 21.564C18.9604 22 17.8403 22 15.6001 22H13.8335C12.126 22 11.2723 22 10.5911 21.7436C9.51306 21.3379 8.66225 20.4871 8.2565 19.409C8.00012 18.7278 8.00012 17.8741 8.00012 16.1667V16.1667"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2.00012"
				y="2"
				width="14"
				height="14"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2.00012"
				y="2"
				width="14"
				height="14"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M16.1668 8V8C17.8742 8 18.7279 8 19.4091 8.25638C20.4872 8.66213 21.338 9.51294 21.7437 10.591C22.0001 11.2722 22.0001 12.1259 22.0001 13.8333V15.6C22.0001 17.8402 22.0001 18.9603 21.5641 19.816C21.1807 20.5686 20.5687 21.1805 19.8161 21.564C18.9604 22 17.8403 22 15.6001 22H13.8335C12.126 22 11.2723 22 10.5911 21.7436C9.51306 21.3379 8.66225 20.4871 8.2565 19.409C8.00012 18.7278 8.00012 17.8741 8.00012 16.1667V16.1667M8.40012 16H9.60012C11.8403 16 12.9604 16 13.8161 15.564C14.5687 15.1805 15.1807 14.5686 15.5641 13.816C16.0001 12.9603 16.0001 11.8402 16.0001 9.6V8.4C16.0001 6.15979 16.0001 5.03968 15.5641 4.18404C15.1807 3.43139 14.5687 2.81947 13.8161 2.43597C12.9604 2 11.8403 2 9.60012 2H8.40012C6.15991 2 5.03981 2 4.18416 2.43597C3.43151 2.81947 2.81959 3.43139 2.4361 4.18404C2.00012 5.03968 2.00012 6.15979 2.00012 8.4V9.6C2.00012 11.8402 2.00012 12.9603 2.4361 13.816C2.81959 14.5686 3.43151 15.1805 4.18416 15.564C5.03981 16 6.15991 16 8.40012 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M7.65012 1.25C5.40991 1.25 4.28981 1.25 3.43416 1.68597C2.68151 2.06947 2.06959 2.68139 1.6861 3.43404C1.25012 4.28969 1.25012 5.40979 1.25012 7.65V10.35C1.25012 12.5902 1.25012 13.7103 1.6861 14.566C2.06959 15.3186 2.68151 15.9305 3.43416 16.314C4.28981 16.75 5.40991 16.75 7.65012 16.75H10.3501C12.5903 16.75 13.7104 16.75 14.5661 16.314C15.3187 15.9305 15.9307 15.3186 16.3141 14.566C16.7501 13.7103 16.7501 12.5902 16.7501 10.35V7.65C16.7501 5.40979 16.7501 4.28969 16.3141 3.43404C15.9307 2.68139 15.3187 2.06947 14.5661 1.68597C13.7104 1.25 12.5903 1.25 10.3501 1.25H7.65012Z"
				fill="currentColor"
			/>
			<path
				d="M18 7.25V10C18 12.8003 18 14.2004 17.455 15.27C16.9757 16.2108 16.2108 16.9757 15.27 17.455C14.2004 18 12.8003 18 10 18H7.25012C7.25012 18.6967 7.25012 19.0451 7.29342 19.3369C7.55194 21.0797 8.92037 22.4482 10.6632 22.7067C10.9551 22.75 11.3034 22.75 12.0001 22.75H16.3501C18.5903 22.75 19.7104 22.75 20.5661 22.314C21.3187 21.9305 21.9307 21.3186 22.3141 20.566C22.7501 19.7103 22.7501 18.5902 22.7501 16.35V12.0001C22.7501 11.3033 22.7501 10.9549 22.7068 10.663C22.4483 8.92023 21.0799 7.55186 19.3371 7.29331C19.0452 7.25 18.6968 7.25 18 7.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2.00006 7V6.5V6.5C2.00006 6.03566 2.00006 5.80349 2.01932 5.60793C2.20637 3.70882 3.70888 2.20631 5.60799 2.01926C5.80355 2 6.03572 2 6.50006 2H9.60006C11.8403 2 12.9604 2 13.816 2.43597C14.5687 2.81947 15.1806 3.43139 15.5641 4.18404C16.0001 5.03968 16.0001 6.15979 16.0001 8.4V9.6C16.0001 11.8402 16.0001 12.9603 15.5641 13.816C15.1806 14.5686 14.5687 15.1805 13.816 15.564C12.9604 16 11.8403 16 9.60006 16H6.50006C6.03572 16 5.80355 16 5.60799 15.9807C3.70888 15.7937 2.20637 14.2912 2.01932 12.3921C2.00006 12.1965 2.00006 11.9643 2.00006 11.5V11.5V11M16.1667 8V8C17.8742 8 18.7279 8 19.4091 8.25638C20.4871 8.66213 21.3379 9.51294 21.7437 10.591C22.0001 11.2722 22.0001 12.1259 22.0001 13.8333V15.6C22.0001 17.8402 22.0001 18.9603 21.5641 19.816C21.1806 20.5686 20.5687 21.1805 19.816 21.564C18.9604 22 17.8403 22 15.6001 22H13.8334C12.126 22 11.2722 22 10.5911 21.7436C9.513 21.3379 8.66219 20.4871 8.25644 19.409C8.00006 18.7278 8.00006 17.8741 8.00006 16.1667V16.1667"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16.1668 8V8C17.8742 8 18.7279 8 19.4091 8.25638C20.4872 8.66213 21.338 9.51294 21.7437 10.591C22.0001 11.2722 22.0001 12.1259 22.0001 13.8333V15.6C22.0001 17.8402 22.0001 18.9603 21.5641 19.816C21.1807 20.5686 20.5687 21.1805 19.8161 21.564C18.9604 22 17.8403 22 15.6001 22H13.8335C12.126 22 11.2723 22 10.5911 21.7436C9.51306 21.3379 8.66225 20.4871 8.2565 19.409C8.00012 18.7278 8.00012 17.8741 8.00012 16.1667V16.1667M8.40012 16H9.60012C11.8403 16 12.9604 16 13.8161 15.564C14.5687 15.1805 15.1807 14.5686 15.5641 13.816C16.0001 12.9603 16.0001 11.8402 16.0001 9.6V8.4C16.0001 6.15979 16.0001 5.03968 15.5641 4.18404C15.1807 3.43139 14.5687 2.81947 13.8161 2.43597C12.9604 2 11.8403 2 9.60012 2H8.40012C6.15991 2 5.03981 2 4.18416 2.43597C3.43151 2.81947 2.81959 3.43139 2.4361 4.18404C2.00012 5.03968 2.00012 6.15979 2.00012 8.4V9.6C2.00012 11.8402 2.00012 12.9603 2.4361 13.816C2.81959 14.5686 3.43151 15.1805 4.18416 15.564C5.03981 16 6.15991 16 8.40012 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M18 7.25V10C18 12.8003 18 14.2004 17.455 15.27C16.9757 16.2108 16.2108 16.9757 15.27 17.455C14.2004 18 12.8003 18 10 18H7.25012C7.25012 18.6967 7.25012 19.0451 7.29342 19.3369C7.55194 21.0797 8.92037 22.4482 10.6632 22.7067C10.9551 22.75 11.3034 22.75 12.0001 22.75H16.3501C18.5903 22.75 19.7104 22.75 20.5661 22.314C21.3187 21.9305 21.9307 21.3186 22.3141 20.566C22.7501 19.7103 22.7501 18.5902 22.7501 16.35V12.0001C22.7501 11.3033 22.7501 10.9549 22.7068 10.663C22.4483 8.92023 21.0799 7.55186 19.3371 7.29331C19.0452 7.25 18.6968 7.25 18 7.25Z"
				fill="currentColor"
			/>
			<path
				d="M7.65012 1.25C5.40991 1.25 4.28981 1.25 3.43416 1.68597C2.68151 2.06947 2.06959 2.68139 1.6861 3.43404C1.25012 4.28969 1.25012 5.40979 1.25012 7.65V10.35C1.25012 12.5902 1.25012 13.7103 1.6861 14.566C2.06959 15.3186 2.68151 15.9305 3.43416 16.314C4.28981 16.75 5.40991 16.75 7.65012 16.75H10.3501C12.5903 16.75 13.7104 16.75 14.5661 16.314C15.3187 15.9305 15.9307 15.3186 16.3141 14.566C16.7501 13.7103 16.7501 12.5902 16.7501 10.35V7.65C16.7501 5.40979 16.7501 4.28969 16.3141 3.43404C15.9307 2.68139 15.3187 2.06947 14.5661 1.68597C13.7104 1.25 12.5903 1.25 10.3501 1.25H7.65012Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
